// Reads a value of unknown shape as text.
//
// Only primitives have a meaningful string form. Objects, arrays and functions stringify to
// "[object Object]" or a comma-joined blob, which then travels on as a table key, a filter value,
// a file name or an error message and reaches the user as noise. This returns the fallback for
// those instead, so a malformed wire value degrades to empty rather than to garbage.
//
// This is the single place that decides how an unknown value becomes text, so no call site has to
// repeat the narrowing.
// The checks narrow the value itself rather than a copy of its typeof, so the conversion below is
// reached with a primitive in hand and never with an unknown the compiler has to take on trust.
export function wireText (value: unknown, fallback = ''): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  return fallback;
}
